// tabs section
const tabs_sections = $(".tabs-section__tabs");
if (tabs_sections) {
  const tabs = $(".tabs-section__tabs-item");

  tabs_sections.on("click", function (e) {
    const target = e.target;
    const parent = this.closest(".tabs-section");
    if (!target.classList.contains("tabs-section__tabs-item")) return;

    const children_tabs = this.querySelectorAll(".tabs-section__tabs-item");
    const children_contents = parent.querySelectorAll(
      ".tabs-section__tab-content"
    );

    children_tabs.forEach((tab) => tab.classList.remove("active"));
    target.classList.add("active");

    children_contents.forEach((content) => content.classList.remove("active"));
    parent
      .querySelector(`#${$(target).attr("data-tab")}`)
      .classList.add("active");

    const target_width = e.target.clientWidth;
    const windowWidth = $(window).width();

    $(this).css(
      "--dash-size",
      `${target_width * (windowWidth > 940 ? 1.3 : 1.1)}px`
    );

    const target_pos = e.target.offsetLeft;
    if (target_pos !== 0) {
      $(this).css(
        "--dash-position",
        `${target_pos - target_width * (windowWidth > 940 ? 0.15 : 0.05)}px`
      );
    } else {
      $(this).css("--dash-position", `${target_pos}`);
    }
  });
  tabs_sections.each((i, item) => {
    item.querySelector(".tabs-section__tabs-item").click();
  });

  $(window).on("resize load", function () {
    $(".tabs-section__tabs").each((i, item) => {
      $(item).css(
        "--border-width",
        `${item.scrollWidth - ($(window).width() > 940 ? 25 : 15)}px`
      );
    });
  });
}